import { FC } from 'react';

import { IA11yWrapper } from './index.android';

export const A11yWrapper: FC<IA11yWrapper> = ({ children }) => <>{children}</>;
